/**
 * Guía: Asesores Comerciales.
 *
 * Contenido derivado del capítulo **38** del manual —§0 (el asesor es gente
 * de fuera y es el sujeto de la pantalla, no quien la usa)— y del flujo F30.
 *
 * El aviso del §0 es lo que ordena la guía: tratar al asesor comercial como
 * «personal de confianza» fue lo que abrió cuatro huecos de autorización en
 * el módulo de compañías.
 */

import type { TourFlow } from '../types';

const ASESORES_PATH = '/commercial-advisors';

export const c38AsesoresComerciales: TourFlow = {
  id: 'admin.commercial-advisors',
  chapter: '38',
  title: 'Asesores y comisiones',
  summary:
    'Gente de fuera que capta comercios y comisiona: qué se administra aquí y qué se decide en otro sitio.',
  href: ASESORES_PATH,
  requiresCountry: true,
  estimatedMin: 3,
  steps: [
    {
      id: 'intro',
      title: 'El asesor es gente de fuera',
      body:
        'No es personal de 121Pass: capta comercios y comisiona sobre sus ventas durante ' +
        'una ventana de meses. Entra al panel porque comparte el mecanismo de acceso, no ' +
        'porque sea del equipo — y eso decide todo lo que puede ver.',
      route: ASESORES_PATH,
    },
    {
      id: 'born-elsewhere',
      title: 'Un asesor no nace aquí',
      body:
        'Nace al aprobar su solicitud, que es lo que crea al colaborador con su rol. Esta ' +
        'pantalla administra lo que pasa después: su porcentaje, su cartera y su estado.',
      target: 'admin.advisors.tabs',
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'commission-band',
      title: 'El porcentaje tiene un techo',
      body:
        'La banda no es arbitraria: por encima de ella el programa deja de sostenerse contra ' +
        'el ingreso de la plataforma. Y aunque el porcentaje lo permita, nunca se liquida ' +
        'más de lo que la plataforma ingresó en ese periodo.',
    },
    {
      id: 'assignment-is-what-pays',
      title: 'La comisión sale de la asignación, no de haber traído al comercio',
      body:
        'Que una compañía declare a un asesor al registrarse no le da nada. Lo que concede ' +
        'la comisión es la asignación que se hace al aprobar la compañía. Ante «traje un ' +
        'comercio y no lo veo», eso es lo primero que se comprueba.',
    },
    {
      id: 'clawback',
      title: 'Lo que hay que recuperarle',
      body:
        'Cuando una venta ya comisionada se devuelve, esa comisión deja de existir. Si ya se ' +
        'le pagó, queda pendiente de recuperar contra lo siguiente que cobre — y por eso su ' +
        'saldo disponible puede bajar sin que se le haya pagado nada.',
    },
    {
      id: 'not-a-manager',
      title: 'Un asesor no administra los paneles de sus comercios',
      body:
        'Ni ve sus tickets. Comisionar y administrar son cosas distintas, y esa frontera es ' +
        'la que hay que sostener cuando pide acceso «para ayudar a su comercio».',
    },
  ],
};
